const EconomicCalendarContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Real-Time Updates</h4>
              </div>
              <p>
                Get the latest data instantly. The calendar refreshes
                automatically, keeping you in sync with global releases the
                moment they’re announced.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Event Impact Filters</h4>
              </div>
              <p>
                Easily identify high, medium, or low-impact events to prioritize
                what matters most to your trading strategy.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Historical Data Comparison</h4>
              </div>
              <p>
                Review past figures and analyze trends to better predict how
                markets might respond to upcoming events.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Custom Alerts</h4>
              </div>
              <p>
                Set personalized notifications for events you care about, from
                inflation reports to GDP announcements, so you never miss
                critical moments.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EconomicCalendarContentFour;
